/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomerResponse from './CustomerResponse';

/**
* The CreateCustomerResponse model module.
* @module model/CreateCustomerResponse
* @version 2020-12-7
*/
export default class CreateCustomerResponse {
    /**
    * Constructs a new <code>CreateCustomerResponse</code>.
    * 顧客登録レスポンス
    * @alias module:model/CreateCustomerResponse
    * @class
    * @param id {Number} 顧客ID
    * @param customer {module:model/CustomerResponse} 
    * @param result {module:model/CreateCustomerResponse.ResultEnum} 
    */

    constructor(id, customer, result) {
        
        
        this['id'] = id;
        this['customer'] = customer;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>CreateCustomerResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateCustomerResponse} obj Optional instance to populate.
    * @return {module:model/CreateCustomerResponse} The populated <code>CreateCustomerResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateCustomerResponse();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('customer')) {
                obj['customer'] = CustomerResponse.constructFromObject(data['customer']);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * 顧客ID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * @member {module:model/CustomerResponse} customer
    */
    'customer' = undefined;
    /**
    * @member {module:model/CreateCustomerResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
